import { SchoolLogo } from "../utils";

const NavHeader = () => {
  return (
    <div data-layout="horizontal-tab">
      <div className="topbar"  style={{backgroundColor:'blue'}}>
        <div className="topbar">
          <div className="topbar-left text-center ml-4">
            <a href="#" className="logo flex items-center">
              <span >
                <img src={SchoolLogo} alt="logo-small" className="logo-sm mt-4 lg:mb-5" />
              </span>
              <span>
                {/* <img src="../assets/images/logo.png" alt="logo-large" className="logo-lg logo-light"/> */}
                <h4 className="logo-lg logo-light text-lg" style={{ color: "#fff" }}>
                  SDU
                </h4>
                <img
                  src={SchoolLogo}
                  alt="logo-large"
                  className="logo-lg logo-dark"
                />
              </span>
            </a>
          </div>
          {/* <nav className="navbar-custom">
        <div id="navigation">
            <ul className="list-unstyled navigation-menu">
                <li className="main-nav-item">
                    <a href="#" className="navbar-link">                                    
                        <span>Dashboard</span>
                    </a>                          
                </li>
                <li className="main-nav-item">
                    <a href="#" className="navbar-link">
                        <span>Apps</span>
                    </a>                          
                </li>
            </ul>
        </div>
    </nav>  */}
        </div>
      </div>
    </div>
  );
};

export default NavHeader;
